import { type FC } from 'react';

import { Content } from '@vakantiesnl/components/src/atoms/Content';
import { AccommodationFacts } from '@vakantiesnl/components/src/blocks/AccommodationFacts';
import { type Search } from '@vakantiesnl/types';

import { useStyles } from './AccommodationInfoContainer.style';
import { TallWave } from '../../atoms/TallWave';

type Props = {
	accommodation: Search.FullAccommodationItem;
};

export const AccommodationInfoContainer: FC<Props> = ({ accommodation }) => {
	const { classes } = useStyles();

	return (
		<>
			<TallWave className={classes.wave} />
			<div className={classes.accoInfoContentWrapper}>
				<div className={classes.accoInfoContent}>
					<Content>
						<AccommodationFacts accommodation={accommodation} />
					</Content>
				</div>
			</div>
		</>
	);
};
